import React, { useState } from 'react';
import MainStyles from '../../../styles/MainStyles'
import Text from '../../Text/';
import './index.css'
import i18n from '../../../locales';
import TextError from '../../Text/TextError';
import NumberFormat from 'react-number-format';

const InputNumber = ({labelText, required, setValue}) => {
	const [isValid, setValid] = useState(null)
	const [isActive, setActive] = useState(null)

	const createPlaceholder = () => {
			return required && !isActive ? labelText + '*' : labelText
	}

  return (
		<div className='form-group form-group-number'>
			<div className='input-number'>
				{ isActive &&
					<Text
						text={createPlaceholder()}
						color={MainStyles.colors.white}
						size={'small'}
						ownClass='label'
					/>
				}
				<NumberFormat
					placeholder={createPlaceholder()}
					onValueChange={(values) => {
						const {value} = values;
						if(value.length > 0) {
							setActive(true)
						} else {
							setActive(false)
						}
						if(value > 0) {
							setValid(true)
						} else {
							setValid(false)
						}
						setValue(value)
				}}/>
			</div>

			{ required && isValid === false &&
				<TextError text={i18n.t('vehicle_form.errors.km_invalid')}/>
			}
		</div>
	)
}

export default InputNumber;